<template>
  <div class="landing-page">
    <div class="login-screen">
      <div class="logo-wrap">
        <img class="brand-logo" src="../../static/images/logo.png" alt="Bottle Pop">
      </div>

      <div class="hero-wrap">
        <img class="hero-image" src="../../static/images/login_pic1.png" alt="Bottle Pop">
      </div>

      <div class="login-overlay">
        <div class="input-div phone-entry">
          <div class="input-item phone-field">
            <div class="input-item2 phone-field-inner">
              <span class="app-en phone-prefix">
                <img src="../../static/images/input_09.png" alt="09">
              </span>
              <input
                v-model="mobile"
                class="input phone-input"
                type="text"
                maxlength="15"
                inputmode="numeric"
                pattern="[0-9]*"
                :placeholder="$t('loginTips')"
                @input="handleMobileInput"
              >
            </div>
          </div>
        </div>

        <div class="plan-group" v-if="primaryButtons.length">
          <div class="login-list top-row" :class="{'single-button': primaryButtons.length === 1}">
            <div
              v-for="plan in primaryButtons"
              :key="plan.type"
              class="drown-li"
              :class="plan.className"
              @click="getType(plan.type)"
            >
              <div class="disflex por" :class="[plan.bgClass, {'is-active': type === plan.type}]">
                <div class="btn-text">{{ plan.label }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="plan-group" v-if="secondaryButtons.length">
          <div class="login-list" :class="{'single-button': secondaryButtons.length === 1}">
            <div
              v-for="plan in secondaryButtons"
              :key="plan.type"
              class="drown-li"
              :class="plan.className"
              @click="getType(plan.type)"
            >
              <div class="disflex por" :class="[plan.bgClass, {'is-active': type === plan.type}]">
                <div class="btn-text">{{ plan.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="login-footer">
        <div class="footer-link" @click="getChange('termsAndCondition')">{{ $t('TC') }}</div>
        <div class="footer-link" @click="getChange('faq')">{{ $t('FAQ') }}</div>
      </div>
    </div>

    <Dialog ref="resubDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="alert-modal ac" slot="mdBox">
        <div class="close" @click="closeTmgDialog"
             style="text-align: right;margin:10px auto;font-size: 50px;margin-right: -20px;">
          <img width="70" src="../../static/images/close.png"/>
        </div>
        <div class="fs33 mt50 ac">{{ $t('re_sub_tip') }}</div>
        <button class="button mt30" @click="goLogin()">{{ $t('subscribe') }}</button>
        <button class="button mt30" @click="login()">{{ $t('Login') }}</button>
      </div>
    </Dialog>
  </div>
</template>
<script>

import Dialog from "../components/dialog.vue";
import CryptoJS from '../../static/js/crypto-js.min.js'

export default {
  components: {
    Dialog,

  },
  data() {
    return {
      isEN: "bur",
      list: [],
      mobile: '',
      password: '',
      type: 'daily',
      showDaily: true,  // 控制 daily 的显示
      showWeekly: true,  // 控制 weekly 的显示
      showMonthly: true, // 控制 monthly 的显示
      //land 配置
      foc_free_land_tip: '',
      foc_daily_free: 0,
      foc_week_free: 0,
      foc_status: 0,
    }
  },
  computed: {
    visiblePlans() {
      const plans = [];
      if (this.showDaily) {
        plans.push({type: 'daily', label: this.$t('Daily'), className: 'plan-single', bgClass: 'day-en'});
      }
      if (this.showWeekly) {
        plans.push({type: 'weekly', label: this.$t('Weekly'), className: 'plan-half', bgClass: 'week-en'});
      }
      if (this.showMonthly) {
        plans.push({type: 'monthly', label: this.$t('Monthly'), className: 'plan-half', bgClass: 'month-en'});
      }
      return plans;
    },
    primaryButtons() {
      if (this.visiblePlans.length === 3) {
        return [this.visiblePlans[0]];
      }
      if (this.visiblePlans.length === 1) {
        return this.visiblePlans;
      }
      return [];
    },
    secondaryButtons() {
      if (this.visiblePlans.length === 3) {
        return this.visiblePlans.slice(1);
      }
      if (this.visiblePlans.length === 1) {
        return [];
      }
      return this.visiblePlans;
    }
  },
  created() {
    this.getLandConfig();
    if (localStorage.getItem('lang')) {
      this.isEN = localStorage.getItem('lang');
    }
    if (this.$route.query.msidn) {
      let ss = this.aesEcbDecrypt(this.$route.query.msidn);
      this.mobile = this.dealPhone_2(ss);
    }
    var type = this.$route.query.type
    if (type === 'day') {
      this.showDaily = true
      this.showWeekly = false
      this.showMonthly = false
      this.type = 'daily'
    } else if (type === 'week') {
      this.showWeekly = true
      this.showDaily = false
      this.showMonthly = false
      this.type = 'weekly'
    } else if (type === 'month') {
      this.showMonthly = true
      this.showDaily = false
      this.showWeekly = false
      this.type = 'monthly'
    } else {
      this.showDaily = true
      this.showWeekly = true
      this.showMonthly = true
    }

  },
  methods: {
    getChange(type) {
      let that = this;
      that.$router.push({path: '/' + type})
    },
    getType(type) {
      this.type = type
      this.userStatus()
    },
    handleMobileInput() {
      this.mobile = this.mobile.replace(/\D/g, '');
    },
    back() {
      this.$router.go(-1);
    },
    userStatus() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      let mobile = that.getMobile();
      const userAgent = navigator.userAgent;
      const deviceId = this.getDeviceId();
      let data = {
        mobile: mobile,
        user_agent: userAgent,
        device_id: deviceId
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/user_status', data, r => {
        that.$parent.loadModal(false);
        that.$parent.returnCode(r, function () {
          if (r.code == 0) {
            that.$utils.alertText(r.msg, 80);
          } else {
            if (r.data.status == 1 || r.data.status == -2) {
              if (r.data.change_device) {
                that.goOtpLogin();
                return;
              } else {
                that.login();
                return;
              }
            }
            if (r.data.status == 3 && r.data.valid == 'Y') {
              that.$refs.resubDialog.showMaskFun();
            } else {
              that.goAtomCg();
            }
          }
        })
      })

    },
    goOtpLogin() {
      let that = this
      let mobile = that.getMobile();
      let encryptedMobile = that.aesEcbEncrypt(mobile);
      this.$router.push({path: '/otp', query: {msidn: encryptedMobile}});
    },
    goAtomCg() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      let mobile = that.getMobile();
      let type = this.type
      that.$parent.loadModal(true);
      let params = new URLSearchParams(this.$route.query);
      // 移除重复项
      params.delete('mobile');
      params.delete('subappid');
      // 添加新参数
      params.set('mobile', mobile);
      params.set('subappid', type);

      let url = '/api/user/get_cg_url?' + params.toString();
      that.$api.get(url, {}, r => {
        that.$parent.loadModal(false);
        if (r.code == 1) {
          window.location.href = r.data + "&reg=reg";
        } else {
          that.$utils.alertText(r.msg, 80);
        }
      })
    },
    goMytelSub(){
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      let mobile = that.getMobile();
      let type  = this.type
      delete queryParams.mobile; // 删除 mobile，避免 URL 里重复
      delete queryParams.type; // 删除 type，避免 URL 里重复
      let queryString = Object.keys(queryParams).length
        ? '&' + Object.entries(queryParams)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&')
        : '';
      that.$parent.loadModal(true);
      let url = '/api/user/sub?mobile='+mobile +'&type='+type+queryString
      that.$api.get(url, {},r =>{
        that.$parent.returnCode(r,function(){
          if (r.code == 1){
            let encryptedMobile = that.aesEcbEncrypt(mobile);
            window.location.href = "https://fillup.ongames.asia/app?msidn=" + encodeURIComponent(encryptedMobile);
          }else{
            that.$parent.loadModal(false);
            that.$utils.alertText(r.msg,80, 3000);
          }
        });
      })
    },
    login() {
      let that = this;
      if (that.mobile === "") {
        that.$utils.alertText(that.$t('phone_error'), 80)
        return
      }
      let mobile = that.getMobile();
      let encryptedMobile = that.aesEcbEncrypt(mobile);
      that.$parent.loadModal(true);
      window.location.href = "https://fillup.ongames.asia/app?msidn=" + encodeURIComponent(encryptedMobile);
    },
    getLandConfig() {
      let that = this
      let url = '/api/land/config'
      that.$api.get(url, {}, r => {
        if (r.code == 1) {
          that.background_image = r.data.back_image
          that.foc_free_land_tip = r.data.free_land_tip
          that.foc_daily_free = r.data.daily_free
          that.foc_week_free = r.data.week_free
          that.foc_status = r.data.status
        }
      })
    },
    getMobile(){
      let mobile = '09' + this.mobile
      mobile = this.dealPhone(mobile)
      return mobile;
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('0909') && phone.length === 13) {
        phone = phone.substring(3);
      }
      if (phone.startsWith('09') && phone.length === 11) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('099') && phone.length === 12) {
        phone = phone.substring(2);
      }
      return phone;
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('97') && phone.length === 10) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('96') && phone.length === 10) {
        phone = phone.substring(1);
      }
      return phone;
    },
    closeTmgDialog() {
      this.$refs.resubDialog.closeMask();
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id');
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('device_id', id);
      }
      return id;
    },
    //加密
    aesEcbEncrypt(plaintext) {
      var key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm"); // 16字节密钥
      var data = CryptoJS.enc.Utf8.parse(plaintext);
      var blockSize = 16;
      var padLen = (blockSize - (data.sigBytes % blockSize)) % blockSize;
      var words = data.words.slice(0);
      var wordArray = CryptoJS.lib.WordArray.create(words, data.sigBytes + padLen);

      var encrypted = CryptoJS.AES.encrypt(wordArray, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.NoPadding
      });
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },
    //解密
    aesEcbDecrypt(ciphertextBase64) {
      try {
        const key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm");
        const encrypted = CryptoJS.enc.Base64.parse(ciphertextBase64);
        const decrypted = CryptoJS.AES.decrypt(
          {ciphertext: encrypted},
          key,
          {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.NoPadding
          }
        );
        return decrypted.toString(CryptoJS.enc.Utf8).replace(/\0+$/, "");
      } catch (e) {

        return "";
      }
    },
  }
}
</script>
<style scoped>
.landing-page {
  min-height: 100vh;
  padding: 0 0 36px;
  background: url(../../static/images/land-bg.png) no-repeat center top;
  background-size: cover !important;
}

.login-screen {
  width: 100%;
  min-height: 100vh;
  padding: 14px 12px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.logo-wrap {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}

.brand-logo {
  width: 236px;
  max-width: 64vw;
}

.hero-wrap {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.hero-image {

  display: block;
}

.login-overlay {
  width: 100%;
  max-width: 570px;
  margin-top: -420px;
  position: relative;
  z-index: 2;
}

.phone-entry {
  margin: 0 auto;
}

.phone-field {
  width: 100% !important;
  height: 100px !important;
  margin: 0 auto !important;
  background: transparent !important;
  border-radius: 50px !important;
}

.phone-field-inner {
  height: 100px !important;
  padding: 0 20px 0 10px;
  border: 0 !important;
  border-radius: 50px !important;
  background: rgba(15, 52, 31, 0.82) !important;
  box-shadow: inset 0 0 0 3px rgba(164, 255, 217, 0.18);
}

.phone-prefix {
  flex: 0 0 auto;
  display: flex !important;
  align-items: center;
  padding: 0 !important;
  margin-right: 14px;
}

.phone-prefix img {
  width: 108px !important;
  height: auto;
  display: block;
}

.phone-input {
  flex: 1;
  min-width: 0;
  height: 100px !important;
  line-height: 100px !important;
  padding: 0 !important;
  margin: 0 !important;
  color: #ffffff !important;
  font-size: 40px !important;
  font-weight: 600 !important;
  background: transparent !important;
  border-radius: 0 !important;
}

.phone-input::placeholder {
  color: rgba(255, 255, 255, 0.95) !important;
  opacity: 1 !important;
  font-size: 24px;
}

.plan-group {
  margin-top: 8px;
}

.top-row {
  max-width: 340px;
}

.login-list {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 14px;
  margin: 0 auto;
}

.login-list.single-button {
  gap: 0;
}

.drown-li {
  margin: 0;
  cursor: pointer;
}

.plan-single {
  width: 340px;
  max-width: 80vw;
}

.plan-half {
  flex: 1;
  min-width: 0;
  max-width: 270px;
}

.login-list .disflex {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 100px;
  background-size: 100% 100% !important;
  transition: transform .2s ease, filter .2s ease;
}

.login-list .disflex.is-active {
  transform: translateY(-2px) scale(1.02);
  filter: brightness(1.05);
}

.btn-text {
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  text-shadow:
    -2px -2px 0 #63208a,
    2px -2px 0 #63208a,
    -2px 2px 0 #63208a,
    2px 2px 0 #63208a,
    0 4px 0 rgba(71, 33, 112, 0.6);
}

.day-en {
  background: url(../../static/images/daily-bg_en.png) no-repeat center !important;
}

.week-en {
  background: url(../../static/images/week-bg_en.png) no-repeat center !important;
}

.month-en {
  background: url(../../static/images/month-bg_en.png) no-repeat center !important;
}

.login-footer {
  width: 100%;
  max-width: 380px;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 28px;
  box-sizing: border-box;
}

.footer-link {
  color: #8b4c12;
  font-size: 30px;
  font-weight: 900;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  text-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

@media (min-width: 768px) {
  .brand-logo {
    width: 270px;
  }

  .hero-image {
    width: 350px;
  }

  .login-overlay {
    max-width: 430px;
    margin-top: -144px;
  }

  .plan-single {
    width: 274px;
  }

  .btn-text {
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue